import { IconButton, Typography } from "@mui/material";
import { MdOutlineClose } from "react-icons/md";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import KeyboardArrowLeftRoundedIcon from "@mui/icons-material/KeyboardArrowLeftRounded";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";

export function ModalTitleText(props: { children: React.ReactNode }) {
  return (
    <Typography variant="subtitle1" color="text.primary" fontWeight={600}>
      {props.children}
    </Typography>
  );
}

export function ModalDescriptionText(props: { children: React.ReactNode }) {
  return (
    <Typography variant="body1" color="text.secondary">
      {props.children}
    </Typography>
  );
}

export function ModalCloseIcon(props: {
  onClick: (a: any) => void;
  disabled?: boolean;
}) {
  return (
    <IconButton
      disabled={props?.disabled}
      size="medium"
      onClick={props.onClick}
    >
      <MdOutlineClose />
    </IconButton>
  );
}

export function ModalBackIcon(props: {
  onClick: (a: any) => void;
  disabled?: boolean;
}) {
  return (
    <IconButton
      disabled={props?.disabled}
      size="medium"
      onClick={props.onClick}
    >
      <ArrowBackIosNewRoundedIcon fontSize="medium" />
    </IconButton>
  );
}
